import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

// Déclaration des fonctions JS globales
// (assurez-vous que country-detector.js est bien chargé via angular.json)
declare function detectVisitorCountry(callback: (country: any, error?: any) => void): Promise<any>;

export interface CountryUser {
    countryCode: string;
    countryName: string;
    [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class CountryUserService {
    private countrySubject = new BehaviorSubject<CountryUser | null>(null);

    get country$(): Observable<CountryUser | null> {
        return this.countrySubject.asObservable();
    }

    detectCountry(): void {
        detectVisitorCountry((country, error) => {
            if (country) {
                this.countrySubject.next(country);
            } else {
                this.countrySubject.next(null);
            }
        });
    }
}
